/*
 * イベント情報
 */
import MicroModal from 'micromodal';
$(function () {

  /*
  * イベント情報カテゴリと、開催日時のラジオボタンがchangeした時
  */
  function requiredControl() {
    var flg_event_date_deside = $('input[name="flg_event_date_desided"]:checked').val();
    var event_category_id = $('input[name="event_category_id"]:checked').val();

    if (flg_event_date_deside == "Y") {
      if(event_category_id == '2' || event_category_id == '3' || event_category_id == '4') {
        // インターンシップで開催日が決定していたら
        $('.internship').show();
        $('.internship .event-date-desided').show();
        $('.internship .event-date-desided .form-group.input-item .form-control').prop("required", true);
        $('.internship .form-group.radio-original input[type="radio"]').prop("required", true);
        $('.internship-oneday').show();
        $('.internship-oneday .form-group.input-item .form-control').prop("required", true);
        $('.no-internship').hide();
        $('.no-internship .event-date-desided').hide();
        $('.no-event-date-desided').hide();
        $('.no-event-date-desided .form-group.input-item .form-control').removeAttr("required");
        $('.no-event-date-desided .form-group.input-item input[type="checkbox"]').removeAttr("required");
        $('.no-internship .event-date-desided .form-group.input-item .form-control').removeAttr("required");
      }else{
        // インターンシップ以外で、開催日が決定していたら
        $('.internship').hide();
        $('.internship .event-date-desided').hide();
        $('.internship .event-date-desided .form-group.input-item .form-control').removeAttr("required");
        $('.internship .form-group.radio-original input[type="radio"]').removeAttr("required");
        $('.internship-oneday').hide();
        $('.internship-oneday .form-group.input-item .form-control').removeAttr("required");
        $('.no-internship').show();
        $('.no-internship .event-date-desided').show();
        $('.no-event-date-desided').hide();
        $('.no-event-date-desided .form-group.input-item .form-control').removeAttr("required");
        $('.no-event-date-desided .form-group.input-item input[type="checkbox"]').removeAttr("required");
        $('.no-internship .event-date-desided .form-group.input-item .form-control').prop("required", true);
      }
    }else if(flg_event_date_deside == "N"){
      if(event_category_id == '2' || event_category_id == '3' || event_category_id == '4') {
        // インターンシップで、開催日が決定していなかったら
        $('.internship').show();
        $('.internship .event-date-desided').hide();
        $('.internship .event-date-desided .form-group.input-item .form-control').removeAttr("required");
        $('.internship .form-group.radio-original input[type="radio"]').prop("required", true);
        $('.internship-oneday').show();
        $('.internship-oneday .form-group.input-item .form-control').prop("required", true);
        $('.no-internship').hide();
        $('.no-internship .event-date-desided').hide();
        $('.no-event-date-desided').show();
        $('.no-event-date-desided .form-group.input-item .form-control').prop("required", true);
        $('.no-internship .event-date-desided .form-group.input-item .form-control').removeAttr("required");
        if($('.no-event-date-desided .form-group.input-item input[type="checkbox"]:checked').length == 0){
          $('.no-event-date-desided .form-group.input-item input[type="checkbox"]').prop("required", true);
        }
      }else{
        // インターンシップ以外で、開催日が決定していなかったら
        $('.internship').hide();
        $('.internship .event-date-desided').hide();
        $('.internship .event-date-desided .form-group.input-item .form-control').removeAttr("required");
        $('.internship .form-group.radio-original input[type="radio"]').removeAttr("required");
        $('.internship-oneday').hide();
        $('.internship-oneday .form-group.input-item .form-control').removeAttr("required");
        $('.no-internship').show();
        $('.no-internship .event-date-desided').hide();
        $('.no-event-date-desided').show();
        $('.no-event-date-desided .form-group.input-item .form-control').prop("required", true);
        $('.no-internship .event-date-desided .form-group.input-item .form-control').removeAttr("required");
        if($('.no-event-date-desided .form-group.input-item input[type="checkbox"]:checked').length == 0){
          $('.no-event-date-desided .form-group.input-item input[type="checkbox"]').prop("required", true);
        }
      }
    }

  }
  /*
  * ロード時
  */
    requiredControl();

  /*
  * イベント情報カテゴリと開催日時radioボタンチェック後
  */
  $(document).on('change','input[name="flg_event_date_desided"], input[name="event_category_id"]', function () {
    requiredControl();
  });
  /*
 * チェックボックス required制御 企業マイページ イベント情報新規登録・編集 開催場所（都道府県+WEB）
//  */
  jQuery(function ($) {
    if ($('.internship-state-checkbox').length) {
        $('.internship-state-checkbox').find('.field-checkbox-label').off().on('click', function () {

          let checkedsum = $('.internship-state-checkbox').find('.field-checkbox-input:checked').length; //チェックが入っているチェックボックスの取得
          if (checkedsum > 0) {//1つでもチェックが入ったらrequired属性削除
              $('.internship-state-checkbox').find('.field-checkbox-input').removeAttr("required"); //required属性の解除
            } else {//チェックが0になったらrequired属性付与
              $('.internship-state-checkbox').find('.field-checkbox-input').prop("required", true); //required属性の付与
            };
        });
      // });
    };
  });


  // 応募URL ロード時inputにrequired属性付与
  $('.application_method_url .form-group.input-item input.form-control').removeAttr("required");
  $(document).on('change','input[name="application_method_type"]', function () {
    var application_method_type = $(this).val();
    // 応募方法：外部サイト
    if (application_method_type == '2') {
      $('.application_method_url').show();
      // 応募URL inputのvalueが2の時にrequired属性付与
      $('.application_method_url .form-group.input-item input.form-control').prop("required", true);
    } else {
      $('.application_method_url').hide();
      // 応募URL inputのvalueが2以外の時にrequired属性削除
      $('.application_method_url .form-group.input-item input.form-control').removeAttr("required");
    }
    // 応募方法：高専Link
    if (application_method_type == '1') {
      $('.event_max').show();
      $('.mail_body').show();
    } else {
      $('.event_max').hide();
      $('.mail_body').hide();
    }
  });
  /*
   * コピー確認ダイアログ
   */
  $('.replicate-event').on('click', function () {
    if (!confirm('このイベント情報をコピーして新規作成します。よろしいですか？')) {
      return false;
    }
    return true;
  });
  /*
   * メール一斉送信確認ダイアログ
   */
  $('#send-event-mail').on('click', function () {
    if (!confirm('メール一斉送信を行います。よろしいですか？')) {
      return false;
    }
    return true;
  });
  /*
   * メールテンプレート選択ボタン
   */
  $('.select-template-btn').on('click', function () {
    if (!confirm('メールテンプレートを反映します。よろしいですか？')) {
      return false;
    }
    $('#form-bloadcast-email input[name="subject"]').val($(this).parent().find('input[name="subject"]').val());
    $('#form-bloadcast-email textarea[name="body"]').val($(this).parent().find('input[name="body"]').val());
    $('#form-bloadcast-email #readonly_attache_path1').val($(this).parent().find('input[name="attache_path1"]').val());
    $('#form-bloadcast-email #readonly_attache_path2').val($(this).parent().find('input[name="attache_path2"]').val());
    $('#form-bloadcast-email #readonly_attache_path3').val($(this).parent().find('input[name="attache_path3"]').val());
    $('#form-bloadcast-email input[name="attache_path1"]').val($(this).parent().find('input[name="attache_path1"]').val());
    $('#form-bloadcast-email input[name="attache_path2"]').val($(this).parent().find('input[name="attache_path2"]').val());
    $('#form-bloadcast-email input[name="attache_path3"]').val($(this).parent().find('input[name="attache_path3"]').val());
    MicroModal.close('modal-mail-template');
    return true;
  });
  /*
   * csv download
   */
  $('#csv-download').click(function () {
    let form = $('.show-search');
    let query = $(form).serializeArray();
    query.push({"name": "format", "value": "csv"});
    window.open($(form)[0].action + '?' + $.param(query), '_blank');
    return false;
  });
/*
 * datetimepicker
 */
  if ($('.wk-datetime').length > 0){
    $.datetimepicker.setLocale('ja');
    $(".wk-datetime").datetimepicker({
      format:'Y-m-d H:i',
    });
  }
});
